import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import styled from "styled-components";
import {
	ButtonCommonTheme,
	FormControl,
	FormGroup,
	ControlLabel,
} from "modules/theme";
import { ModalFooter, FormWrapper, FormColumn } from "modules/theme";
import {
	ModalForm,
	ModalFormContainer,
} from "../../../../theme/theme1/common/styles/main";
const ResetCss = styled.div`
	img {
		height: auto;
		width: auto;
		border-radius: 0px;
	}
	.DraftEditor-root {
		z-index: 0;
		direction: ltr;
		text-align: left;
		background: #ffffff;
		box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
		border-radius: 10px;
		height: auto;
		width: 95%;
		min-height: 113px;
		margin: 15px auto;
		padding: 5px;
	}
`;

class SmsTempleteAddEdit extends Component {
	constructor(props) {
		super(props);

		this.saveData = this.saveData.bind(this);
		this.renderFormGroup = this.renderFormGroup.bind(this);

		this.mAPI = new APIManager();
		if (this.props.editData && this.props.editData._id) {
			this.state = {
				name: this.props.editData.name,
				templete: this.props.editData.templete,
				editorState: this.props.editData.templete,
			};
		} else {
			this.state = {
				name: "",
				editorState: "",
			};
		}
	}

	renderFormGroup(label, props) {
		return (
			<FormGroup>
				<ControlLabel required={props.required}>{label}</ControlLabel>
				<FormControl {...props} />
			</FormGroup>
		);
	}

	resetAllData() {
		this.setState({
			name: "",
			type: "",
		});
	}

	apiResponse(errorCode, data) {
		if (errorCode === 201) {
			let message =
				data && data.message ? data.message : "Successfully Done";
			Alert.success(`${message}`);
			this.resetAllData();
			this.props.closeModal(true);
		} else {
			let message =
				data && data.message
					? data.message
					: "Something wrong happened";
			Alert.error(`${message}`);
		}
	}
	saveData(e) {
		let _this = this;
		e.preventDefault();
		this.props.clearSearchField();
		let name = this.state.name.trim();
		let editorState = this.state.editorState.trim();
		let tData = {
			name: name,
			type: "text",
			templete: editorState,
		};

		if (this.props.editData && this.props.editData._id) {
			this.mAPI.sendPostAPI(
				`setting/sms-templete/${this.props.editData._id}`,
				tData,
				(data) => {
					console.log(JSON.stringify(data, null, 2));
					if (data) {
						_this.resetAllData();
						_this.props.closeModal(true);
						Alert.success(data.message);
					}
				},
				(errorCode, data) => {
					this.apiResponse(errorCode, data);
				},
				"private",
				{ id: tData._id },
				"PUT"
			);
		} else {
			this.mAPI.sendPostAPI(
				"setting/sms-templete",
				tData,
				(data) => {
					Alert.success(`${data.message}`);
					this.resetAllData();
					this.props.update();
					this.props.closeModal(true);
				},
				(errorCode, data) => {
					this.apiResponse(errorCode, data);
				}
			);
		}
	}

	onEditorStateChange = (editorState) => {
		console.log(editorState);
		this.setState({ editorState });
	};

	render() {
		const { __ } = this.context;
		const { modalType } = this.props;
		console.log("infoData", this.props.infoData);
		return (
			<ModalForm onSubmit={(e) => this.saveData(e)}>
				<ModalFormContainer>
					<FormWrapper>
						<FormColumn>
							{this.renderFormGroup("Name", {
								placeholder: "Name",
								defaultValue: "",
								autoFocus: true,
								required: true,
								id: "name",
								maxLength: 25,
								value: this.state.name,
								onChange: (e) => {
									this.setState({ name: e.target.value });
								},
							})}
						</FormColumn>
					</FormWrapper>
					<FormWrapper>
						<FormColumn>
							<ResetCss>
								<FormGroup>
									{this.renderFormGroup("Template", {
										placeholder: "Add Template here...",
										componentClass: "textarea",
										defaultValue: "",
										required: true,
										id: "template",
										style: { padding: "20px" },
										value: this.state.editorState,
										onChange: (e) => {
											this.setState({
												editorState: e.target.value,
											});
										},
									})}
								</FormGroup>
							</ResetCss>
						</FormColumn>
					</FormWrapper>
				</ModalFormContainer>

				<ModalFooter modalType={modalType}>
					<ButtonCommonTheme
						type="greyModalBtn"
						onClick={() => this.props.closeModal()}
					>
						Cancel
					</ButtonCommonTheme>
					<ButtonCommonTheme
						type="blueModalBtn"
						btnType="submit"
						style={{ float: "right" }}
					>
						{this.props.editData && this.props.editData._id
							? "Update"
							: "Add"}
					</ButtonCommonTheme>
				</ModalFooter>
			</ModalForm>
		);
	}
}

SmsTempleteAddEdit.propTypes = {
	group: PropTypes.array,
};

SmsTempleteAddEdit.contextTypes = {
	__: PropTypes.func,
};

export default SmsTempleteAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsTemplete/components/SmsTempleteAddEdit.js